import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { THEME } from '../../utils/theme';
import Badge from '../ui/Badge';

const FilterDrawer = ({ isOpen, onClose, userStatusFilters, setUserStatusFilters, userFavoritesFilters, setUserFavoritesFilters, userRecommendationsFilters, setUserRecommendationsFilters, typeFilter, setTypeFilter, sortBy, setSortBy, onlineOnly, setOnlineOnly, controllerFilter, setControllerFilter, tagFilter, setTagFilter, allTags, unratedOnly, setUnratedOnly, presets, onSavePreset, onLoadPreset, onDeletePreset, squadMembers }) => {
  const [showSavePreset, setShowSavePreset] = useState(false);
  const [presetName, setPresetName] = useState('');
  const clearAll = () => { setUserStatusFilters({}); setUserFavoritesFilters({}); setUserRecommendationsFilters({}); setOnlineOnly(false); setControllerFilter(''); setTagFilter([]); setUnratedOnly(false); setTypeFilter('all'); };
  // Count active filters
  const favCount = Object.values(userFavoritesFilters).filter(Boolean).length;
  const recCount = Object.values(userRecommendationsFilters).filter(Boolean).length;
  const activeCount = favCount + recCount + (typeFilter !== 'all' ? 1 : 0) + (onlineOnly ? 1 : 0) + (controllerFilter ? 1 : 0) + (tagFilter.length > 0 ? 1 : 0) + (unratedOnly ? 1 : 0);

  if (!isOpen) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000 }} onClick={onClose}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(2px)' }} />
      <div style={{
        position: 'absolute', right: 0, top: 0, bottom: 0, width: '320px', maxWidth: '90vw', background: THEME.bgCard,
        borderLeft: `1px solid ${THEME.border}`, padding: '24px', overflowY: 'auto', animation: 'slideIn 0.2s ease', boxShadow: `-10px 0 40px ${THEME.shadowHeavy}`
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h3 style={{ margin: 0, color: THEME.text, fontSize: '18px', fontWeight: '700' }}>Advanced Filters</h3>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {activeCount > 0 && <button onClick={clearAll} style={{ background: 'transparent', border: 'none', color: THEME.textMuted, fontSize: '13px', cursor: 'pointer' }}>Clear ({activeCount})</button>}
            <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', color: THEME.textMuted, width: '32px', height: '32px', borderRadius: '8px', fontSize: '18px', cursor: 'pointer' }}>&times;</button>
          </div>
        </div>

        {/* Filter Presets */}
        {presets && (
          <div style={{ marginBottom: '20px', padding: '12px', background: THEME.bg, borderRadius: '10px', border: `1px solid ${THEME.border}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <span style={{ fontSize: '11px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '600' }}>Saved Presets</span>
              {activeCount > 0 && (
                <button onClick={() => setShowSavePreset(true)} style={{ background: `${THEME.success}20`, color: THEME.success, border: `1px solid ${THEME.success}40`, borderRadius: '6px', padding: '4px 10px', fontSize: '11px', fontWeight: '600', cursor: 'pointer' }}>
                  + Save Current
                </button>
              )}
            </div>
            {showSavePreset && (
              <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
                <input
                  type="text"
                  placeholder="Preset name..."
                  value={presetName}
                  onChange={e => setPresetName(e.target.value)}
                  style={{ flex: 1, background: THEME.bgCard, border: `1px solid ${THEME.border}`, borderRadius: '6px', padding: '6px 10px', color: THEME.text, fontSize: '12px' }}
                  autoFocus
                  onKeyDown={e => { if (e.key === 'Enter' && presetName.trim()) { onSavePreset(presetName.trim()); setPresetName(''); setShowSavePreset(false); } }}
                />
                <button onClick={() => { if (presetName.trim()) { onSavePreset(presetName.trim()); setPresetName(''); setShowSavePreset(false); } }} style={{ background: THEME.success, color: '#000', border: 'none', borderRadius: '6px', padding: '6px 10px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>Save</button>
                <button onClick={() => { setPresetName(''); setShowSavePreset(false); }} style={{ background: THEME.bgCard, color: THEME.textMuted, border: `1px solid ${THEME.border}`, borderRadius: '6px', padding: '6px 8px', fontSize: '12px', cursor: 'pointer' }}>✕</button>
              </div>
            )}
            {presets.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {presets.map(preset => (
                  <div key={preset.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: THEME.bgCard, borderRadius: '6px', padding: '8px 10px', border: `1px solid ${THEME.border}` }}>
                    <button onClick={() => onLoadPreset(preset)} style={{ flex: 1, background: 'transparent', border: 'none', color: THEME.text, fontSize: '13px', fontWeight: '500', textAlign: 'left', cursor: 'pointer' }} title="Click to load">
                      {preset.name}
                    </button>
                    <button onClick={() => onDeletePreset(preset.id)} style={{ background: 'transparent', border: 'none', color: THEME.danger, fontSize: '14px', cursor: 'pointer', padding: '2px 4px' }} title="Delete">✕</button>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ color: THEME.textDim, fontSize: '11px', margin: 0 }}>No saved presets. Apply some filters and save them for quick access.</p>
            )}
          </div>
        )}

        <p style={{ color: THEME.textDim, fontSize: '12px', marginBottom: '20px' }}>Use the tabs above the game list for status filtering. These are additional filters.</p>

        {/* User-specific Filters - Dynamic based on squad members */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '11px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '14px', fontWeight: '600' }}>Favorites & Recommendations</div>
          <div style={{ display: 'grid', gridTemplateColumns: squadMembers?.length > 2 ? '1fr' : '1fr 1fr', gap: '16px' }}>
            {(squadMembers || []).map(member => {
              const userColor = member.theme_color || THEME.success;
              const username = member.username;
              const isFavActive = userFavoritesFilters[username] || false;
              const isRecActive = userRecommendationsFilters[username] || false;
              return (
                <div key={username}>
                  <div style={{ color: userColor, fontWeight: '700', fontSize: '12px', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: userColor }} />
                    {member.founder_icon && <span>{member.founder_icon}</span>}
                    {member.display_name?.toUpperCase() || username.toUpperCase()}
                  </div>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '6px 0', color: isFavActive ? '#fbbf24' : THEME.textMuted }}>
                    <input type="checkbox" checked={isFavActive} onChange={() => setUserFavoritesFilters(prev => ({ ...prev, [username]: !isFavActive }))} style={{ width: '16px', height: '16px', accentColor: '#fbbf24' }} />
                    <span style={{ fontSize: '13px' }}>★ Favorites</span>
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '6px 0', color: isRecActive ? THEME.success : THEME.textMuted }}>
                    <input type="checkbox" checked={isRecActive} onChange={() => setUserRecommendationsFilters(prev => ({ ...prev, [username]: !isRecActive }))} style={{ width: '16px', height: '16px', accentColor: THEME.success }} />
                    <span style={{ fontSize: '13px' }}>⬆ Recommended</span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        {/* Type Filter */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '11px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', fontWeight: '600' }}>Game Type</div>
          <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} style={{ width: '100%', background: THEME.bg, border: `1px solid ${THEME.border}`, borderRadius: '10px', padding: '12px 14px', color: THEME.text, fontSize: '14px' }}>
            <option value="all">All Types</option>
            <option value="co-op">Co-op</option>
            <option value="pvp">PvP</option>
            <option value="mmo">MMO</option>
          </select>
        </div>

        {/* Sort */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '11px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', fontWeight: '600' }}>Sort By</div>
          <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ width: '100%', background: THEME.bg, border: `1px solid ${THEME.border}`, borderRadius: '10px', padding: '12px 14px', color: THEME.text, fontSize: '14px' }}>
            <option value="playtime">Combined Playtime</option>
            {squadMembers && squadMembers.length > 0 ? squadMembers.slice(0, 2).map(m => (
              <option key={`pt_${m.username}`} value={`playtime_${m.username}`}>{m.display_name || m.username}'s Playtime</option>
            )) : (
              <>
                <option value="playtime_omega">Omega's Playtime</option>
                <option value="playtime_supe">Supe's Playtime</option>
              </>
            )}
            <option value="name">Name (A-Z)</option>
            <option value="metacritic">Metacritic</option>
            <option value="rating">Rating</option>
            <option value="release">Release Date</option>
            <option value="added">Recently Added</option>
          </select>
        </div>

        {/* Controller Support Filter */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '11px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', fontWeight: '600' }}>Controller Support 🎮</div>
          <select value={controllerFilter} onChange={e => setControllerFilter(e.target.value)} style={{ width: '100%', background: THEME.bg, border: `1px solid ${THEME.border}`, borderRadius: '10px', padding: '12px 14px', color: THEME.text, fontSize: '14px' }}>
            <option value="">Any (Include All)</option>
            <option value="any">Has Controller Support</option>
            <option value="full">Full Controller Support</option>
            <option value="partial">Partial Controller Support</option>
          </select>
        </div>

        {/* Tag Filter */}
        {allTags && allTags.length > 0 && (
          <div style={{ marginBottom: '24px' }}>
            <div style={{ fontSize: '11px', color: THEME.textMuted, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', fontWeight: '600' }}>Tags</div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
              {allTags.map(tag => {
                const isSelected = tagFilter.includes(tag.id);
                return (
                  <button
                    key={tag.id}
                    onClick={() => setTagFilter(prev => isSelected ? prev.filter(id => id !== tag.id) : [...prev, tag.id])}
                    style={{
                      background: isSelected ? `${tag.color}40` : THEME.bg,
                      color: isSelected ? tag.color : THEME.textMuted,
                      border: `1px solid ${isSelected ? tag.color : THEME.border}`,
                      borderRadius: '14px', padding: '6px 12px', fontSize: '12px', fontWeight: '500',
                      cursor: 'pointer', transition: 'all 0.15s'
                    }}
                  >
                    #{tag.name}
                  </button>
                );
              })}
            </div>
            {tagFilter.length > 0 && (
              <button onClick={() => setTagFilter([])} style={{ background: 'transparent', border: 'none', color: THEME.textMuted, fontSize: '11px', marginTop: '8px', cursor: 'pointer' }}>Clear tags</button>
            )}
          </div>
        )}

        {/* Toggles */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', color: THEME.text, fontSize: '14px' }}>
            <input type="checkbox" checked={onlineOnly} onChange={e => setOnlineOnly(e.target.checked)} style={{ width: '18px', height: '18px', accentColor: THEME.supe }} />
            Online Multiplayer Only
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', color: THEME.text, fontSize: '14px' }}>
            <input type="checkbox" checked={unratedOnly} onChange={e => setUnratedOnly(e.target.checked)} style={{ width: '18px', height: '18px', accentColor: THEME.warning }} />
            Unrated Games Only
          </label>
        </div>
      </div>
    </div>
  );
};

export default FilterDrawer;
